import { render, staticRenderFns } from "./AppActions.vue?vue&type=template&id=b90fc974&scoped=true"
import script from "./AppActions.vue?vue&type=script&lang=js"
export * from "./AppActions.vue?vue&type=script&lang=js"
import style0 from "./AppActions.vue?vue&type=style&index=0&id=b90fc974&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90fc974",
  null
  
)

export default component.exports